// Recovery for stale lazy-loaded chunks after a deploy.
//
// When a new build ships, a tab still running the previous build may try to
// lazy-load a hashed chunk the new build no longer serves → a 404 / "Failed to
// fetch dynamically imported module". index.html is served no-store, so a
// reload pulls the current chunk hashes and recovers. A short sessionStorage
// window guards against a reload loop if an asset is genuinely missing.

const RELOAD_KEY = 'stale-chunk-reload-at'
const RELOAD_WINDOW_MS = 10_000

export function isChunkLoadError(error: unknown): boolean {
  const msg = error instanceof Error ? error.message : String(error ?? '')
  return /dynamically imported module|importing a module script failed/i.test(msg)
}

/** Reload once to recover a stale chunk. Returns false (without reloading) if a
 *  reload was already attempted within the guard window. */
export function reloadForStaleChunk(): boolean {
  let last = 0
  try {
    last = Number(sessionStorage.getItem(RELOAD_KEY) || '0')
  } catch {
    // sessionStorage unavailable (e.g. strict privacy mode) — proceed to reload.
  }
  if (Date.now() - last < RELOAD_WINDOW_MS) return false
  try {
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
  } catch {
    // ignore — the reload itself is what matters.
  }
  window.location.reload()
  return true
}
